import { Component, Input } from '@angular/core';

import { IVideoReviewManualCommentEntry } from './VideoReviewTypes';
import { VideoReviewEntryBase } from './VideoReviewEntryBase.Directive';

@Component({
	selector: 'video-review-manual-comment-entry',
	host: { '[class]': 'styles.manualEntryRoot' },
	template: `
		<div [ngClass]="styles.entry">
			<div [ngClass]="styles.entryIconWrapper">
				<vb-profile-picture
					[altTxt]="'UserProfile_ProfilePicture' | translate"
					[profileUrl]="manualComment.user.profileImageUri"
					[size]="'large'">
				</vb-profile-picture>
			</div>
			<div [ngClass]="styles.entryDetails">
				<div [ngClass]="styles.entryHeading">
					<span [ngClass]="styles.manualEntryHeadingName">{{ manualComment.user.fullName || manualComment.user.userName }}</span>
					&nbsp;-&nbsp;{{ manualComment.when | vbDateTimeMedium }}
					<div [ngClass]="styles.entrySubHeading">
						{{ 'ApprovalProcess_AI_ContentAnalysis_ApproverStep' | translate : {'0': manualComment.stepName } }}
					</div>
				</div>
				<div [ngClass]="styles.entryContent">
					<button *ngIf="manualComment.segment !== null" type="button" class="btn btn-transparent" [ngClass]="styles.entryBtn" (click)="onEntryClick(manualComment.segment)">
						&#64;{{ manualComment.segment * SecondMs | vbTimespan : showHoursInTimestamp : true }}&nbsp;&nbsp;-&nbsp;
					</button>
					<span [innerHTML]="manualComment.comment"></span>
				</div>
				<div [ngClass]="styles.entryFooter">
					<div *ngIf="!isReadOnlyMode" [ngClass]="styles.entryFooterBtns">
						<button type="button" class="btn btn-transparent" [ngClass]="styles.entryBtn" (click)="onReplyClick()">
							<span class="vb-icon vb-icon-center vb-icon-return" [ngClass]="styles.replyIcon"></span>&nbsp;&nbsp;
							{{ 'Reply' | translate }}
						</button>
						<ng-container *ngIf="isDeleteVisible">
							<span>|</span>
							<button type="button" class="btn btn-transparent" [ngClass]="[styles.entryBtn, styles.deleteBtn]" (click)="onDeleteClick()">
								{{ 'Delete' | translate }}
							</button>
						</ng-container>
					</div>
					<video-review-reply-input
						*ngIf="showReplyInput && !isReadOnlyMode"
						[ngClass]="styles.entryReplyInput"
						(replySubmitted)="onReplySubmitted($event)"
						(hideReplyInput)="onHideReplyInput($event)">
					</video-review-reply-input>
					<video-review-reply-entry
						*ngFor="let reply of manualComment.replies"
						[isReadOnlyMode]="isReadOnlyMode"
						[reply]="reply"
						[currentUserId]="currentUserId"
						(deleteClicked)="onDeleteReplyClicked($event)">
					</video-review-reply-entry>
				</div>
			</div>
		</div>
	`
})
export class VideoReviewManualCommentEntryComponent extends VideoReviewEntryBase {
	@Input({ required: true }) public manualComment: IVideoReviewManualCommentEntry;

	public isDeleteVisible: boolean;

	public ngOnInit(): void {
		this.isDeleteVisible = this.manualComment.user.id === this.currentUserId;
	}

	public onDeleteClick(): void {
		this.DialogService.openConfirmationDialog({
			title: this.TranslateService.instant('DeleteComment'),
			message: this.TranslateService.instant('DeleteComment_Confirm'),
			actionText: this.TranslateService.instant('Yes'),
			cancelText: this.TranslateService.instant('No'),
			themed: true
		}).result
			.then(() => {
				this.VideoReviewService.deleteManualComment(this.videoId, this.manualComment.stepId, this.manualComment.id);
			})
			.catch(this.noop);
	}

	public onReplySubmitted(reply: string): void {
		this.VideoReviewService.addManualCommentReply(this.videoId, this.manualComment.stepId, this.manualComment.id, reply);
	}

	public onDeleteReplyClicked(replyId: string): void {
		this.VideoReviewService.deleteManualCommentReply(this.videoId, this.manualComment.stepId, this.manualComment.id, replyId);
	}

}
